export default __webpack_public_path__ + "static/media/sg6.90915c83.png";